import React from 'react';
import styled from 'styled-components';
import { convertHexToRGBA } from '@utils/usefulFuncs';
import { Working } from './Working';

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  background-color: ${({ theme }) => convertHexToRGBA(theme.themeColors.componentNoOpacity, 0.97)};
  z-index: 10000;
`;

const MessageWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProgressOverlay = ({ message }) => {
  return (
    <Wrapper>
      <MessageWrapper>
        <Working message={message} />
      </MessageWrapper>
    </Wrapper>
  );
};
